import { LAYOUT_CONTROLS, DEFAULT_LAYOUT_SETTINGS, sanitizeLayoutSettings, saveLayoutSettings, settingToSlider, sliderToSetting, SLIDER_STEPS } from "./layout-settings.js";

export function installLayoutControls(initial, onChange, isPaused) {
  let settings = { ...initial };
  const panel = document.querySelector("#layoutControls"), fields = panel.querySelector("#layoutFields");
  if (matchMedia("(max-width: 760px)").matches) panel.open = false;
  fields.innerHTML = Object.entries(LAYOUT_CONTROLS).map(([key, c]) => `
    <div class="layout-control">
      <label for="layout-${key}">${c.label}</label><output for="layout-${key}" id="layout-value-${key}"></output>
      <input id="layout-${key}" data-layout-setting="${key}" type="range" min="${c.logarithmic ? 0 : c.min}" max="${c.logarithmic ? SLIDER_STEPS : c.max}" step="${c.logarithmic ? 1 : c.step}" aria-describedby="layout-hint-${key}">
      <small id="layout-hint-${key}">${c.hint}${c.logarithmic ? ` Échelle logarithmique : ${c.min.toLocaleString("fr-FR", { maximumFractionDigits: 5 })} à ${c.max.toLocaleString("fr-FR")}.` : ""}</small>
    </div>`).join("");
  function paint() {
    for (const key of Object.keys(LAYOUT_CONTROLS)) {
      const input = fields.querySelector(`#layout-${key}`), output = fields.querySelector(`#layout-value-${key}`);
      input.value = settingToSlider(key, settings[key]);
      const text = key === "displayScale" ? `${Math.round(settings[key] * 100)} %` : settings[key].toLocaleString("fr-FR", { maximumFractionDigits: 5 });
      input.setAttribute("aria-valuetext", text); output.value = text;
    }
  }
  function apply() {
    paint(); onChange({ ...settings });
    try { saveLayoutSettings(localStorage, settings); } catch { /* Controls still work without storage. */ }
    panel.querySelector("#layoutFeedback").textContent = isPaused()
      ? "En pause : reprendre pour appliquer les forces."
      : "Réglages appliqués · Recentrer pour tout afficher.";
  }
  fields.addEventListener("input", event => {
    const key = event.target.dataset.layoutSetting;
    if (!Object.hasOwn(LAYOUT_CONTROLS, key)) return;
    settings = sanitizeLayoutSettings({ ...settings, [key]: sliderToSetting(key, event.target.value) }); apply();
  });
  panel.querySelector("#resetLayoutSettings").addEventListener("click", () => { settings = { ...DEFAULT_LAYOUT_SETTINGS }; apply(); });
  document.querySelector("#pauseButton").addEventListener("click", () => {
    panel.querySelector("#layoutFeedback").textContent = isPaused() ? "En pause : reprendre pour appliquer les forces." : "Recentrer pour tout afficher.";
  });
  paint();
}
